import { Box, Snackbar } from '@mui/material';
import React from 'react';
import { createPortal } from 'react-dom';

interface SnackbarProps {
  message: string;
  open: boolean;
  onClose: () => void;
}

export default function CustomSnackbar({ message, open, onClose }: SnackbarProps) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Box sx={{ width: 500 }}>
      {createPortal(
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={6000}
          open={open}
          onClose={handleClose}
          message={message}
          className="my-account-snackbar"
          onClick={handleClose}
        />,
        document.body
      )}
    </Box>
  );
}
